var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3090_71933)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3090_71933",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H0V28H34V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3090_71933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 2H6C3.79086 2 2 3.79086 2 6V22C2 24.2091 3.79086 26 6 26H28C30.2091 26 32 24.2091 32 22V6C32 3.79086 30.2091 2 28 2Z",
    stroke: "#BA71AE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3649 10.0129L10.225 19H8.13989L5 10.0129H6.83978L9.19469 17.1588L11.5373 10.0129H13.3649Z",
    fill: "#BA71AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6439 17.2876H16.2341L15.6699 19H13.867L16.9455 10H18.9448L22.0233 19H20.2081L19.6439 17.2876ZM19.1778 15.8455L17.939 12.0858L16.7002 15.8455H19.1778Z",
    fill: "#BA71AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.0129V11.4678H26.7187V19H25.0015V11.4678H22.7202V10.0129H29Z",
    fill: "#BA71AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3090_71933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVat);
export default __webpack_public_path__ + "static/media/vat.8025564fb5a96bb141bb48452a2e800b.svg";
export { ForwardRef as ReactComponent };